import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const QuebecIcon = (props: BaseProvinceIconProps) => {
  return (
    <g
      id="QC"
      {...props}
    >
      <path
        d="M237.8,154.1c0.6,0,1.4,0.5,1.7,1c2,2.8,3.9,5.8,5.9,8.6c0.3,0.5,0.7,1,1.1,1.2c2.5,1.1,5.1,2.1,7.8,3.2
            c0.1,0.1,0.2,0.1,0.4,0.1c0.5,0,0.9-0.3,1-0.8c0.6-4.1,1.2-8.2,1.8-12.4c0.1-0.4,0.4-0.7,0.8-0.7c0.2,0,0.5,0.1,0.7,0.4
            c3.7,5.5,7.3,10.8,10.9,16.1c0.4,0.6,0.4,1.4-0.1,1.9c-2,2.2-4.1,4.4-6.1,6.6c-0.9,1-1.8,1.9-2.7,2.9c-1.5,1.7-1.5,2.1,0.2,3.5
            c6.5,5.3,13,10.5,19.4,15.9c0.7,0.6,1.3,0.9,1.9,0.9c0.5,0,1.1-0.2,1.8-0.7c1.2-0.9,31-21,32.6-22c0.4-0.3,0.9-0.4,1.3-0.4
            c0.6,0,1.2,0.2,1.6,0.6l3.9,3.5c0.6,0.5,0.9,1.2,0.8,2c0,0.5-0.1,1.1-0.1,1.4c0,1.6-0.2,4.3-0.3,5.5c0,0.4-0.1,0.7-0.4,1.1l-1,1.6
            c-0.2,0.4-0.6,0.7-1,0.9c-4.1,1.9-27.1,13.1-35.2,17.4c-0.6,0.3-1.3,1.1-1.4,1.7c-0.7,4.3-1.3,8.5-2,13.2c-0.1,0.4,0.2,0.6,0.5,0.6
            c0.1,0,0.3-0.1,0.4-0.1c3.8-3.5,9.3-8.6,11.3-10.4c0.2-0.2,0.4-0.2,0.6-0.2c0.3,0,0.6,0.1,0.8,0.4c0.2,0.3,0.2,0.7,0,1
            c-1.3,2.3-6.8,11.8-9.2,16.3c-0.5,0.7-0.8,1.3-1.1,2l-2.1,5.2c-0.1,0.4-0.2,0.8-0.2,1.2l1.3,11.4c0,0.4,0,0.8-0.2,1.2l-0.3,0.7
            c-0.2,0.4-0.4,0.8-0.8,1c-3.5,2.6-7.1,5.2-10.9,7.9c-0.3,0.2-0.6,0.3-0.9,0.3c-0.4,0-0.8-0.1-1.1-0.4c-1.2-1.2-2.5-2.4-3.8-3.4
            c-0.7-0.6-1.6-1-2.5-1.2c-8.5-1.6-17.1-3.1-25.7-4.6c-1.3-0.2-1.9-0.8-2.4-2c-5.4-14.1-10.7-28.1-14.5-42.8c-0.2-1-0.2-2.2,0.2-3.1
            c1.6-3.6,3.3-7,5-10.5c0.5-0.9,0.4-1.6-0.2-2.5c-3.1-4.3-6.2-8.6-9.1-12.9c-0.6-0.9-1.1-2.1-1-3.2c0.5-4.5-0.8-8.3-3.5-11.9
            c-1.5-2.1-3.9-5.9-5.7-8.9c-1.1-1.8,0.1-4.1,2.2-4.1C217.3,154.9,230.4,154.4,237.8,154.1L237.8,154.1z"
      />
      <path
        d="M300.8,210.7C300.8,210.7,300.9,210.7,300.8,210.7c1.7,0,3.3,0.2,5,0.4c0.5,0,0.9,0.4,0.8,0.9
            c0,0.4-0.3,0.7-0.7,0.8c-1.5,0.4-2.9,0.7-4.4,1.1c-1,0.2-2,0.6-3,0.7c-0.1,0-0.3,0-0.4,0c-1.2,0-2.4-0.5-3.6-0.7
            c-0.4-0.1-0.6-0.4-0.7-0.7c-0.1-0.5,0.2-0.9,0.6-1c1.4-0.3,2.7-0.7,4.1-1C299.4,210.9,300,210.7,300.8,210.7L300.8,210.7z"
      />
      <path
        d="M329.9,213.9c0.1,0,0.2,0,0.3,0.1c0.9,0.4,0,1.4-0.2,2s-0.3,1.4-0.4,2.1c0,0.1,0,0.3,0,0.6
            c0,0.5-0.1,1.6-0.7,1.6c-0.1,0-0.2,0-0.4-0.1c-0.5-0.2-0.7-1.2-0.6-1.7c0.3-1.4,0.3-2.6,1-3.9C329.2,214.2,329.6,213.9,329.9,213.9
            L329.9,213.9z"
      />
    </g>
  );
};
